<template>
  <div class="i-banner">
    <ul>
      <w-carousel indicator-position="outside" arrow="never" :interval="7000" trigger="click" loop>
        <w-carousel-item v-for="item in bannerList" :key="item.bannerId">
          <div class="i-banner-center" >
            <a v-if="item.link" target="_blank" :href="item.link">
              <div :style="'background-image: url('+item.imgSrc+'/resize,w_' + (width > 1920 ? 3840 : 1920) + ')'"></div>
            </a>
            <template v-else-if="item.videoLink">
              <span class="video-link" @click="$emit('play', item.videoLink)"></span>
              <div :style="'background-image: url('+item.imgSrc+'/resize,w_' + (width > 1920 ? 3840 : 1920) + ')'"></div>
            </template>
            <div v-else :style="'background-image: url('+item.imgSrc+'/resize,w_' + (width > 1920 ? 3840 : 1920) + ')'"></div>
          </div>
        </w-carousel-item>
      </w-carousel>
    </ul>
  </div>
</template>

<script>
import AppService from '@/assets/service/App'
export default {
  name: 'Banner',
  data () {
    return {
      width: window.screen.width,
      bannerList: []
    }
  },
  created () {
    this.getBannerList()
  },
  methods: {
    getBannerList (){
      AppService.getHomeBanner().then((res) => {
        if (+res.code === 200){
          this.bannerList = res.data
        }
      })
    }
  }
}
</script>

<style  lang="less">
  .login-main{
    .i-banner{
      height: 628px;
      /*margin-top: 72px;*/
    }
  }
  .i-banner{
    .w-carousel__container {
      height: 628px;
    }
    .w-carousel__indicators {
      position: absolute;
      bottom: 20px;
      height: 10px;
      .w-carousel__indicator{
        width:10px;
        height: 10px;
        border-radius: 50%;
        /*border:1px solid #fff;*/
        background-color: rgba(255, 255, 255, .3);
        display: inline-block;
        margin: 0px 5px;
        text-indent: 100em;
        overflow: hidden;
        cursor: pointer;
        padding: 0px;
        position: relative;
        button{
          display: none;
        }
      }
      .is-active{
        background: #fff;
      }
    }
    .i-banner-center{
      text-align: center;
      height: 100%;
      position: relative;
      div{
        height: 100%;
        background-position: center center;
        background-repeat: no-repeat;
        background-size: cover;
        // background-size: auto 700px;
      }
      .video-link {
        position: absolute;
        left: 50%;
        bottom: 150px;
        transform: translate(-50%, 0);
        display: inline-block;
        width: 64px;
        height: 64px;
        background: url("~@/assets/images/indexpage/index/media-play@2x.png") no-repeat center center;
        background-size: contain;
        cursor: pointer;
        border-radius: 50%;
        &:hover {
          box-shadow: 0 3px 9px 0 rgba(33, 37, 48, 1);
        }
      }
    }
  }
</style>
